import { useCallback, useState } from "react";

const rethrowServerErrorStatus = 500;

type RethrowToErrorBoundaryResult = {
  resetUnhandledError: () => void;
  rethrowIfUnhandled: () => void;
  setUnhandledError: () => void;
};

export const useRethrowToErrorBoundary = (): RethrowToErrorBoundaryResult => {
  const [hasUnhandledError, setHasUnhandledError] = useState(false);

  const setUnhandledError = useCallback(() => {
    setHasUnhandledError(true);
  }, []);

  const resetUnhandledError = useCallback(() => {
    setHasUnhandledError(false);
  }, []);

  const rethrowIfUnhandled = useCallback(() => {
    if (hasUnhandledError) {
      throw rethrowServerErrorStatus;
    }
  }, [hasUnhandledError]);

  return {
    resetUnhandledError,
    rethrowIfUnhandled,
    setUnhandledError,
  };
};